import { CustomRoute } from "../core/main/routing/CustomRoute";
import CheckLogicScreen from "./checks/CheckLogicScreen";
import CheckEditionScreen from "./checks/type/CheckEditionScreen";
import CommentaryScreen from "./commentary/CommentaryScreen";
import EnnemyTracker from "./ennemy/EnnemyTracker";
import EnnemyTrackerHorizontal from "./ennemy/EnnemyTrackerHorizontal";
import EnnemyTrackerVertical from "./ennemy/EnnemyTrackerVertical";
import SeedDetailsScreen from "./seedGenerator/SeedDetailsScreen";
import SeedGeneratorScreen from "./seedGenerator/SeedGeneratorScreen";
import HintsNotesTracker from "./standard/HintsNotesTracker";
import ItemsTracker from "./standard/ItemsTracker";
import OotTrackerSettingsScreen from "./standard/OotTrackerSettingsScreen";
import SongTracker from "./standard/SongTracker";
import { PickBanScreen } from "./tournoifr/PickBanScreen";
import MixedPoolTracker from "./mixpool/MixedPoolTracker";
import OotTricksScreen from "./tricks/OotTricksScreen";
import CreateTrickScreen from "./tricks/form/CreateTrickScreen";
import LeagueTracker from "./league/LeagueTracker";
import EntranceTracker from "./mixpool/EntranceTracker";
import TournoiFrancoTracker from "./tournoifr/tracker/TournoiFrancoTracker";
import RslBeginnerSettingsTracker from "./rsl/beginner/RslBeginnerSettingsTracker";
import ScrubTracker from "./scrubs/ScrubsTracker";
import MainTournamentTracker from "./mainTournament/MainTournamentTracker";
import PhasmophobiaTracker from "../phasmophobia/PhasmophobiaTracker";
import S6SettingsTracker from "./rsl/S6SettingsTracker";
import S7SettingsTracker from "./rsl/S7SettingsTracker";
import MultiworldTracker from "./multiworld/MultiworldTracker";

const OotrTrackerRouteConfig: Array<CustomRoute> = [
    {
        path: "phasmophobia",
        title: "Phasmoooo",
        component: PhasmophobiaTracker,
        childrens: [
        ],
        permissions: []
    },
    {
        path: "ootr/tournoi/fr/pick-ban",
        title: "OoTR Tournoi Francophone - Pick / Ban",
        component: PickBanScreen,
        childrens: [
        ],
        permissions: []
    },
    {
        path: "ootr/generator",
        title: "OoTR Seed Generator",
        component: SeedGeneratorScreen,
        childrens: [
            {
                path: "seed/:id",
                title: "OoTR Seed",
                component: SeedDetailsScreen,
                childrens: [

                ],
                permissions: []
            }
        ],
        permissions: []
    },
    {
        path: "ootr/commentary",
        title: "OoTR Commentary",
        component: CommentaryScreen,
        childrens: [
            {
                path: ":id",
                title: "OoTR Commentary",
                component: CommentaryScreen,
                childrens: [

                ],
                permissions: []
            }
        ],
        permissions: []
    },
    {
        path: "ootr/tracker",
        title: "OoT Tracker",
        component: ItemsTracker,
        childrens: [
            {
                path: "mixed-pool",
                title: "OoT Mixed Pool",
                component: MixedPoolTracker,
                childrens: [
                    {
                        path: "entrances",
                        title: "OoT Mixed Pool Entrance",
                        component: EntranceTracker,
                        childrens: [
                        ],
                        permissions: []
                    },
                ],
                permissions: []
            },
            {
                path: "league",
                title: "OoT League",
                component: LeagueTracker,
                childrens: [
                ],
                permissions: []
            },
            {
                path: "s8",
                title: "OoT Main Tournament S8",
                component: MainTournamentTracker,
                childrens: [
                ],
                permissions: []
            },
            {
                path: "tournoi-franco",
                title: "OoT Tournoi Franco",
                component: TournoiFrancoTracker,


                childrens: [
                ],
                permissions: []
            },
            {
                path: "scrubs",
                title: "OoT Scrubs",
                component: ScrubTracker,


                childrens: [
                ],
                permissions: []
            },
            {
                path: "rsl/beginner",
                title: "OoT Tracker RSL Beginner",
                component: RslBeginnerSettingsTracker,

                childrens: [
                ],
                permissions: []
            },
            {
                path: "rsl/s6",
                title: "OoT Tracker RSL Beginner",
                component: S6SettingsTracker,
                childrens: [
                ],
                permissions: []
            },
            {
                path: "rsl/s7",
                title: "OoT Tracker RSL Beginner",
                component: S7SettingsTracker,
                childrens: [
                ],
                permissions: []
            },
            {
                path: "multiworld/s5",
                title: "OoT Tracker Multiworld",
                component: MultiworldTracker,
                childrens: [
                ],
                permissions: []
            },
            {
                path: "settings",
                title: "OoT Tracker Settings",
                component: OotTrackerSettingsScreen,
                childrens: [
                ],
                permissions: []
            },
            {
                path: "items",
                title: "OoT Tracker Items",
                component: ItemsTracker,
                childrens: [
                ],
                permissions: []
            },
            {
                path: "notes",
                title: "OoT Tracker Items",
                component: HintsNotesTracker,
                childrens: [
                ],
                permissions: []
            },
            {
                path: "ennemy",
                title: "OoT Ennemy Tracker",
                component: EnnemyTracker,
                childrens: [
                    {
                        path: "vertical",
                        title: "OoT Ennemy Tracker",
                        component: EnnemyTrackerVertical,
                        childrens: [],
                        permissions: []
                    },
                    {
                        path: "horizontal",
                        title: "OoT Ennemy Tracker",
                        component: EnnemyTrackerHorizontal,
                        childrens: [],
                        permissions: []
                    }],
                permissions: []
            }
        ],
        permissions: []
    },
    {
        path: "ootr/tracker/songs",
        title: "OoT Tracker",
        component: SongTracker,
        childrens: [
        ],
        permissions: []
    },
    {
        path: "ootr/tricks",
        title: "OoT Tricks",
        component: OotTricksScreen,
        childrens: [
            {
                path: "create",
                title: "Create Oot Trick",
                component: CreateTrickScreen,
                childrens: [],
                permissions: []
            },
            {
                path: ":id/edit",
                title: "Edit Oot Trick",
                component: CreateTrickScreen,
                childrens: [],
                permissions: []
            }
        ],
        permissions: []
    },
    {
        path: "ootr/checks",
        title: "Oot Checks",
        component: CheckLogicScreen,
        childrens: [
            {
                path: ":id/edit",
                title: "Oot Check Edition",
                component: CheckEditionScreen,
                childrens: [],
                permissions: []

            }
        ],
        permissions: []
    },
    {
        path: "ootr/commentary",
        title: "Oot Commentary",
        component: CommentaryScreen,
        childrens: [

        ],
        permissions: []
    }
]

export default OotrTrackerRouteConfig;